import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { crmConstants, crmModels } from '..';

export const usePipeTemplateId = (props: { id?: number } = {}) =>
  useQuery<crmModels.IPipeTemplate>({
    queryKey: [crmConstants.queryKeys.PIPE_TEMPLATE_ID, props.id],
    queryFn: async () => {
      const res = await $api.get(`/v1/pipe/template/${props?.id}`);

      return res?.data?.data;
    },
    enabled: !!props.id
  });
